"use client";

import Button from '@/components/button';
import styles from './_hcp-acth.module.scss';
import { useRef, useState } from 'react';
import Video from '@/components/video';
import PageAnchor from '@/components/page-anchor';
import getOptimizedImageUrl from '@/util/getOptimizedImageUrl';

export default function HcpMoaActh() {
  const videoRef = useRef(null);
  const [showTranscript, setShowTranscript] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const transcript = <>
    <p>Length: 02:57</p>
    <p>VOICEOVER: The continuum of 21-OH deficiency in congenital adrenal hyperplasia, or CAH, impairs cortisol synthesis.</p>
    <p>Consequently, excess cholesterol-derived steroid hormone precursors, such as progesterone and 17-hydroxyprogesterone, are shunted to androgen synthesis.</p>
    <p>The lack of cortisol also results in a loss of negative feedback in the hypothalamic-pituitary-adrenal, or HPA, axis.</p>
    <p>Without this negative feedback, the hypothalamus continues to secrete corticotropin-releasing factor, or CRF, leading to ongoing activation of CRF type 1 receptors and excess production of adrenocorticotropic hormone, or ACTH, that is released into broad circulation.</p>
    <p>CRF is a primary regulator of the HPA axis. In people with CAH, continued CRF release drives overproduction of both ACTH and downstream adrenal androgens.</p>
    <p>Interfering with CRF binding to CRF type 1 receptors could provide a targeted way to reduce ACTH and downstream androgen overproduction and allow for lower doses of high-dose glucocorticoids, or GCs.</p>
    <p>With CRENESSITY (crinecerfont), this is finally possible.</p>
    <p>CRENESSITY is the first and only CRF type 1 receptor antagonist that is FDA approved to treat classic CAH. By selectively blocking CRF from binding to CRF type 1 receptors in the pituitary gland, CRENESSITY directly inhibits ACTH secretion to lower circulating levels of ACTH.</p>
    <p>In patients with CAH, excess ACTH secretion leads to chronic overstimulation of the adrenal glands, an overaccumulation of steroid hormone precursors, and excess production of adrenal androgens.</p>
    <p>Because CRENESSITY directly reduces ACTH secretion, it also leads to a downstream reduction in adrenal androgens. This in turn allows for lower doses of GCs.</p>
    <p>For 70 years, high doses of GCs were given to both replace missing cortisol and engage the negative feedback loop in the HPA axis in an attempt to control ACTH and androgens.</p>
    <p>However, this has required a balancing act to weigh the side effects and comorbidities related to high-dose GC use against the symptoms of poor androgen control.</p>
    <p>And when taking GCs alone, 2/3 of patients with CAH still have poorly managed androgen levels.</p>
    <p>More direct reduction of ACTH secretion and downstream adrenal androgen production: CRENESSITY is a breakthrough therapy that can transform the way we think about CAH.</p>
  </>;

  function handleReadTranscript() {
    setShowTranscript(!showTranscript);
  }
  

  const videoImageHTML = <div className={styles.content}>
    <div className={styles.image_wrapper}>
      <Video
        ref={videoRef}
        url="https://player.vimeo.com/progressive_redirect/playback/1055781182/rendition/1080p/file.mp4?loc=external&signature=c2ddfd805dbcb44e2fecee54a55f24ec672d4c5af1b5de089b15fe292878aa68"
        title="MOA Video"
        poster={getOptimizedImageUrl("/images/page/hcp/acth/MOA_Video-Poster.png", 1332)}
        caption="/images/page/hcp/videos/captions/CFT-HCP-MOA-Video.vtt"
        gtmEventLabel="MOA Video Play/Pause Video"
        id="moa-video"
        autoplay={true}
        onVideoPause={() => setVideoPlaying(false)}
        onVideoPlay={() => setVideoPlaying(true)}
      />
    </div>
  </div>;

  return (
    <>
      <PageAnchor anchorId="watch-video" />
      <section className={styles.container}>
        <div className="container">

          <div className={styles.wrapper}>
            <div className={styles.content}>
              
                <div className={styles.content_video}>

                  <h2 className={`${showTranscript ? 'tablet:hidden' : 'block'}`}>Watch the video to learn more about how CRENESSITY works toward rebalancing the HPA axis.</h2>

                  <div className="tablet:hidden">
                    {videoImageHTML}
                  </div>
                  {!showTranscript &&
                  <div className={styles.button_container}>
                    {/* <div className={styles.button_wrapper}>
                      <Button
                        type="button"
                        variant="outline--eggplant"
                        onClick={handleClick}
                        data-gtm-event-category="Action"
                        data-gtm-event-action="Click"
                        data-gtm-event-label="Play the MOA Video"

                      >Play the MOA Video</Button>
                    </div> */}
                    <div className={styles.button_wrapper}>
                      <Button
                        type="button"
                        variant="outline--eggplant"
                        onClick={handleReadTranscript}
                        data-gtm-event-category="Action"
                        data-gtm-event-action="Click"
                        data-gtm-event-label="Read video transcript - MOA Video"
                      >Read video transcript</Button>
                    </div>
                  </div>
                  }
                  {showTranscript &&
                  <div className={styles.content_transcript}>
                    <div className={`${styles.transcript} video-transcript`}>{transcript}</div>
                    <div className={styles.button_wrapper}>
                      <Button
                        type="button"
                        variant="outline--eggplant"
                        onClick={handleReadTranscript}
                        data-gtm-event-category="Action"
                        data-gtm-event-action="Click"
                        data-gtm-event-label="Close video transcript - MOA Video"
                      >Close video transcript</Button>
                    </div>
                  </div>}
                </div>
            </div>
            <div className="hidden tablet:block">
              {videoImageHTML}
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
}
